import Section from '@/components/elements/Section';
import PricingCard from '@/components/landing/PricingCard';
import type { PricingPlan } from '@/types/pricing.types';
import { forwardRef } from 'react';

interface LandingPricingProps {
  content: {
    plans: Array<PricingPlan>;
    title?: string;
    description?: string;
  };
  background?: 'grey' | 'white';
}

const LandingPricing = forwardRef<HTMLDivElement, LandingPricingProps>(({ content, background = 'grey' }, ref) => {
  return (
    <Section id='pricing' ref={ref} background={background} title={content.title} description={content.description}>
      <div className='mt-8 grid grid-cols-1 md:grid-cols-2 gap-6'>
        {content.plans.map((plan, index) => (
          <PricingCard key={index} plan={plan} background={background} />
        ))}
      </div>
    </Section>
  );
});

LandingPricing.displayName = 'LandingPricing';

export default LandingPricing;
